import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import groupBy from 'lodash.groupby';
import update from 'immutability-helper';
import ReferralOptions from './ReferralOptions';
import ReferralsList from './ReferralsList';
import ReferralTerms from './ReferralTerms';
import whiteboardImg from '../../../assets/images/whiteboard-human.svg';
import { analyticsTrack } from '../../analyticsUtils';
import './ReferralsIndexContainer.scss';
function EmptyReferralsSection() {
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 8,
    sm: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: "no-referrals"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "hero-header my-referrals"
  }, "My Invites"), /*#__PURE__*/React.createElement("div", {
    className: "body-text-1"
  }, /*#__PURE__*/React.createElement("div", null, "You haven't invited anybody yet."), /*#__PURE__*/React.createElement("div", null, "The progress of your referrals will appear here.")))), /*#__PURE__*/React.createElement(Col, {
    md: 4,
    sm: 6
  }, /*#__PURE__*/React.createElement("img", {
    src: whiteboardImg,
    className: "d-none d-sm-block",
    alt: "",
    height: "300"
  })));
}
var ReferralsIndexContainer = /*#__PURE__*/function (_Component) {
  function ReferralsIndexContainer(props) {
    var _this;
    _classCallCheck(this, ReferralsIndexContainer);
    _this = _callSuper(this, ReferralsIndexContainer, [props]);
    _this.state = {
      showInviteModal: _this.props.returnFromLinkedIn,
      whichInviteModal: _this.props.isConsultant ? 'consultant' : 'employer',
      referrals: props.referrals,
      showTermsModal: false
    };
    _this.handleShowInviteModal = _this.handleShowInviteModal.bind(_this);
    _this.handleCloseInviteModal = _this.handleCloseInviteModal.bind(_this);
    _this.handleShowTermsModal = _this.handleShowTermsModal.bind(_this);
    _this.handleCloseTermsModal = _this.handleCloseTermsModal.bind(_this);
    _this.addReferrals = _this.addReferrals.bind(_this);
    return _this;
  }
  _inherits(ReferralsIndexContainer, _Component);
  return _createClass(ReferralsIndexContainer, [{
    key: "handleShowInviteModal",
    value: function handleShowInviteModal(whichModal) {
      var isConsultant = this.props.isConsultant;
      analyticsTrack('Clicked on Refer Now', {
        location: "".concat(isConsultant ? 'Consultant' : 'Employer', " Referral Program"),
        referred_user_type: whichModal
      });
      this.setState({
        showInviteModal: true,
        whichInviteModal: whichModal
      });
    }
  }, {
    key: "handleCloseInviteModal",
    value: function handleCloseInviteModal() {
      this.setState({
        showInviteModal: false
      });
    }
  }, {
    key: "handleShowTermsModal",
    value: function handleShowTermsModal() {
      this.setState({
        showTermsModal: true
      });
    }
  }, {
    key: "handleCloseTermsModal",
    value: function handleCloseTermsModal() {
      this.setState({
        showTermsModal: false
      });
    }
  }, {
    key: "addReferrals",
    value: function addReferrals(newReferrals) {
      var referrals = this.state.referrals;
      this.setState({
        referrals: update(referrals, {
          $unshift: newReferrals
        })
      });
    }
  }, {
    key: "renderReferralButtonAndModal",
    value: function renderReferralButtonAndModal(modalType, buttonText, buttonStyle, showSocialMediaShareButtons) {
      var _this2 = this;
      var colorScheme = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var isConsultant = this.props.isConsultant;
      var _this$state = this.state,
        showInviteModal = _this$state.showInviteModal,
        whichInviteModal = _this$state.whichInviteModal;
      return /*#__PURE__*/React.createElement("div", {
        className: "mb-2"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-".concat(buttonStyle, " bigger-button mt-5 refer-").concat(modalType, "s"),
        onClick: function onClick() {
          return _this2.handleShowInviteModal(modalType);
        }
      }, buttonText), /*#__PURE__*/React.createElement(Modal, {
        show: showInviteModal && modalType === whichInviteModal,
        onHide: this.handleCloseInviteModal
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(ReferralOptions, _extends({}, this.props, {
        addReferrals: this.addReferrals,
        location: "".concat(isConsultant ? 'Consultant' : 'Employer', " Referral Program"),
        referredUserType: modalType,
        isConsultant: isConsultant,
        showSocialMediaShareButtons: showSocialMediaShareButtons,
        colorScheme: colorScheme
      })))));
    }
  }, {
    key: "renderReferralsLists",
    value: function renderReferralsLists() {
      var referrals = this.state.referrals;
      var _this$props = this.props,
        isConsultant = _this$props.isConsultant,
        csrfToken = _this$props.csrfToken;
      if (!referrals || !referrals.length) {
        return /*#__PURE__*/React.createElement(EmptyReferralsSection, null);
      }
      var sortedReferrals = groupBy(referrals, 'referred_user_type');
      return /*#__PURE__*/React.createElement("div", {
        className: "all-referrals"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "hero-header my-referrals"
      }, "My Referrals"), /*#__PURE__*/React.createElement("div", {
        className: "d-none d-sm-block body-text-1 mb-24"
      }, "Follow your referrals' progress and be part of their success."), isConsultant ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "mb-70"
      }, /*#__PURE__*/React.createElement(ReferralsList, {
        referrals: sortedReferrals.consultant || [],
        csrfToken: csrfToken,
        userType: "consultant",
        headerTitle: "Consultant Referrals (".concat(sortedReferrals.consultant && sortedReferrals.consultant.length, ")")
      })), /*#__PURE__*/React.createElement(ReferralsList, {
        referrals: sortedReferrals.employer || [],
        csrfToken: csrfToken,
        userType: "employer",
        headerTitle: "Employer Referrals (".concat(sortedReferrals.employer && sortedReferrals.employer.length, ")")
      })) : /*#__PURE__*/React.createElement(ReferralsList, {
        referrals: referrals,
        csrfToken: csrfToken,
        userType: "employer"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var isConsultant = this.props.isConsultant;
      return /*#__PURE__*/React.createElement("div", {
        className: "g-column--between style-guide"
      }, /*#__PURE__*/React.createElement("div", {
        className: "referrals-banner text-center"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "hero-header bold  mb-3 "
      }, /*#__PURE__*/React.createElement("div", {
        className: "d-none d-sm-block"
      }, isConsultant ? 'Connect consultants with relevant projects matching their interest and expertise.' : 'Connect innovative life science companies with top-tier talent.', /*#__PURE__*/React.createElement("br", null)), !isConsultant && 'Accelerate the life science industry!'), /*#__PURE__*/React.createElement("h1", {
        className: "subtext mb-4 g-row g-row--centered"
      }, isConsultant ? 'Invite consultants to join Clora & earn $500 when they are hired!' : 'Get an employer to publish a project & earn $500 when it matches with a consultant!', isConsultant && /*#__PURE__*/React.createElement(OverlayTrigger, {
        placement: "right",
        delay: {
          show: 100
        },
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "referral-tooltip"
        }, "You can invite both consultants and employers. Earn $500 when a consultant you invited is hired for their first project and/or when an employer hires their first consultant.")
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-info-circle"
      }))), isConsultant ? /*#__PURE__*/React.createElement("div", {
        className: "referrals-buttons"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-flex-6 text-center employer-button-modal"
      }, this.renderReferralButtonAndModal('employer', 'Invite Employer', 'secondary', false, 'purple')), /*#__PURE__*/React.createElement("div", {
        className: "g-flex-6 text-center consultant-button-modal"
      }, this.renderReferralButtonAndModal('consultant', 'Invite Consultant', 'primary', true, 'green')))) : this.renderReferralButtonAndModal('employer', 'Refer Now!', 'primary rounded-cta', true)), /*#__PURE__*/React.createElement("div", {
        className: "white-background g-column g-column--centered"
      }, /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "referrals-container"
      }, this.renderReferralsLists()), /*#__PURE__*/React.createElement("div", {
        className: "referrals-explanation mt-4 mb-5"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "hero-header mb-3"
      }, isConsultant ? 'How it works' : 'How referrals work', /*#__PURE__*/React.createElement("span", {
        className: "body-text-2 normal-weight ps-3"
      }, /*#__PURE__*/React.createElement("a", {
        href: "# ",
        id: "".concat(isConsultant ? 'consultant' : 'employer', "-referral-terms"),
        className: " p-0",
        onClick: this.handleShowTermsModal
      }, "Read terms"))), /*#__PURE__*/React.createElement(Row, {
        className: "g-flex-justify-space-between g-row"
      }, /*#__PURE__*/React.createElement(Col, {
        md: 3
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row--always"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "pe-3 hero-header"
      }, "1."), /*#__PURE__*/React.createElement("div", {
        className: "explain-text"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "mb-2"
      }, isConsultant ? 'Invite your network' : 'Refer an employer'), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, "Share your personal referral link with your network.")))), /*#__PURE__*/React.createElement(Col, {
        md: 1
      }), /*#__PURE__*/React.createElement(Col, {
        md: 3
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row--always"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "pr-10 hero-header"
      }, "2."), /*#__PURE__*/React.createElement("div", {
        className: "explain-text"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "mb-2"
      }, "Track their progress"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, "Wait for your referral to accept your invite and", ' ', isConsultant ? 'apply to a project.' : 'publish a project in our platform.')))), /*#__PURE__*/React.createElement(Col, {
        md: 1
      }), /*#__PURE__*/React.createElement(Col, {
        md: 3
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row--always"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "hero-header pe-3"
      }, "3."), /*#__PURE__*/React.createElement("div", {
        className: "explain-text"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "mb-2"
      }, "Earn $500"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, isConsultant ? 'When a consultant you invited is hired for their first project and/or when an employer hires their first consultant' : "Get paid when your referral's project matches a consultant.")))))))), /*#__PURE__*/React.createElement(Modal, {
        show: this.state.showTermsModal,
        onHide: this.handleCloseTermsModal,
        size: "lg",
        dialogClassName: "modal-50w"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(ReferralTerms, {
        isEmployer: !isConsultant
      }))));
    }
  }]);
}(Component);
ReferralsIndexContainer.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  referrals: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  returnFromLinkedIn: PropTypes.bool,
  isConsultant: PropTypes.bool
};
ReferralsIndexContainer.defaultProps = {
  returnFromLinkedIn: false,
  isConsultant: false
};
export default ReferralsIndexContainer;